<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="当前余额" prop="balance">
                        <input-number :value="info.balance" disabled>
                            <span slot="append">元</span>
                        </input-number>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="支付方式" prop="payType">
                        <Select v-model="info.payType">
                            <Option
                                v-for="item in cusPayTypeList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.text }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="充值金额" prop="rechargeAmount">
                        <input-number v-model="info.rechargeAmount">
                            <span slot="append">元</span>
                        </input-number>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="收款时间" prop="payTime">
                        <DatePicker
                            v-model="info.payTime"
                            transfer
                            type="datetime"
                            clearable
                            style="width: 100%"
                        >
                        </DatePicker>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="备注" prop="remark">
                        <Input
                            v-model="info.remark"
                            type="textarea"
                            :row="5"
                            placeholder
                        />
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { orderRechargeAdd, houseWeFee } from '@/api/order'
import Dict from '_u/dict'
import { multiply } from '@/views/common/u-contract'

export default {
    name: 'OrderRechargeForm',
    props: {
        houseId: {
            type: [String, Number],
            default: '',
        },
        houseName: {
            type: String,
            default: '',
        },
        cusId: {
            type: [String, Number],
            default: '',
        },
        cusName: {
            type: String,
            default: '',
        },
        cusMobile: {
            type: String,
            default: '',
        },
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {
                houseId: this.houseId,
                houseName: this.houseName,
                cusId: this.cusId,
                cusName: this.cusName,
                cusMobile: this.cusMobile,
                balance: 0,
                rechargeAmount: 0,
                remark: '',
                payType: '',
                payTime: new Date(),
            },
            dict: {
                payType: Dict.NULL,
            },
        }
    },
    computed: {
        ruleValidate() {
            const validateRechargeAmount = (rule, value, callback) => {
                value = parseFloat(value)
                if (value === 0) {
                    callback(new Error('充值金额不能为0'))
                } else {
                    callback()
                }
            }
            return {
                rechargeAmount: [
                    { required: true, message: '充值金额必填' },
                    { validator: validateRechargeAmount, trigger: 'blur' },
                ],
                payTime: [
                    { required: true, message: '收款时间必填' },
                    { validator: validateRechargeAmount, trigger: 'blur' },
                ],
                payType: [
                    { required: true, message: '支付方式必填' },
                    { validator: validateRechargeAmount, trigger: 'blur' },
                ],
            }
        },
        cusPayTypeList() {
            return this.dict.payType.toList()
        },
    },
    methods: {},
    mounted() {
        var $info = this.$refs.info
        const btns = [
            { type: 'primary', name: 'confirm', text: '确定' },
            { type: 'default', name: 'cancel', text: '取消' },
        ]
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            // houseWeFee(this.houseId)
            //     .then((res) => {
            //         this.info.balance = res.data?.entity?.weBalance / 100 || 0

            //     })
            //     .finally(() => {
            //         next()
            //     })

            //获取词典
            Promise.all([
                this.$dict.get(['pay_type']),
                houseWeFee(this.houseId),
            ])
                .then((args) => {
                    var [dictGroup, res] = args
                    Object.assign(this.dict, dictGroup)
                    this.info.balance = res.data?.entity?.weBalance / 100 || 0
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)
                    formData.rechargeAmount = multiply(formData.rechargeAmount)
                    formData.balance = multiply(formData.balance)

                    return orderRechargeAdd(formData)
                })
                .then((res) => {
                    this.$Message.success('充值成功')
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped></style>
